<template>
  <hic-dialog append-to-body @open="open" :close-on-click-modal="false" :visible="visible" width="80rem" top="4vh" @close="cancel">
    <el-row style="height: 47rem">
      <hic-report-panel ref="rpt" v-model="value" />
    </el-row>
  </hic-dialog>
</template>
<script>
  export default {
    props: {
      visible: Boolean,
      value: Object,
    },
    data() {
      return {};
    },
    methods: {
      open() {
        if (this.$refs.rpt) this.$refs.rpt.init();
      },
      cancel() {
        this.$emit("update:visible", false);
        this.$emit("cancel");
      },
    },
  };
</script>
